import { render } from "./ChatMessages.vue?vue&type=template&id=6d49e459&scoped=true&bindings={}"
import script from "./ChatMessages.vue?vue&type=script&lang=ts"
export * from "./ChatMessages.vue?vue&type=script&lang=ts"

import "./ChatMessages.vue?vue&type=style&index=0&id=6d49e459&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d49e459"

export default script